import { IProviderProductFilters, IFilterAvailableProducts, IProviderProductObject } from '../types'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class ProviderProductService {
  public async getManyByOrganizationId(
    dto: IProviderProductFilters
  ): Promise<{ result: IProviderProductObject[]; count: number }> {
    const path = Paths.providerProduct.getManyByOrganizationId
    const result = await serverApi.get<{ result: IProviderProductObject[]; count: number }>(path, {
      params: dto
    })
    return result.data
  }

  public async fetchOne(productId: string) {
    const path = Paths.providerProduct.getOneWithPricingById.replace(':id', productId)
    return await serverApi.get(path).then(({ data }) => data)
  }

  public async deactivateOne(id: string, deactivationDate: Date) {
    return await serverApi.put(Paths.providerProduct.deactivate, { id, deactivationDate }).then(({ data }) => data)
  }

  public async activateOne(id: string) {
    return await serverApi.put(`${Paths.providerProduct.activate}/${id}`).then(({ data }) => data)
  }

  public async createOne(product: IProviderProductObject) {
    return serverApi.post<any>(Paths.providerProduct.base, product).then(({ data }) => data)
  }

  public async saveOne(product: IProviderProductObject): Promise<IProviderProductObject> {
    const productDTO = {
      allottedTimeAtPickup: product.allottedTimeAtPickup,
      allottedTimeAtDropoff: product.allottedTimeAtDropoff,
      id: product.id,
      name: product.name,
      internalName: product.internalName,
      integrationId: product.integrationId,
      serviceLevelId: product.serviceLevelId,
      description: product.description,
      externalUrl: product.externalUrl,
      pricing: product.pricing,
      organizationId: product.organizationId,
      estimatedLoadingTime: product.estimatedLoadingTime,
      bookingPriority: product.bookingPriority
    }
    const result = await serverApi.put<IProviderProductObject>(Paths.providerProduct.base, productDTO)
    return result.data
  }

  public async removeOne(id: string) {
    return await serverApi.delete(`${Paths.providerProduct.base}/${id}`).then(({ data }) => data)
  }

  public async findAvailableProducts(params: { lat: number; lng: number; riderId: string }): Promise<any> {
    const response = await serverApi.get(Paths.providerProduct.findAvailable, { params })
    return response.data
  }
}

const providerProductService = new ProviderProductService()

export { providerProductService }



// WEBPACK FOOTER //
// ./src/services/ProviderProduct.ts